import store from '../store';
import { authActions } from '../store/auth';
import { userActions } from '../store/user';

// In dev the API runs on a different port than the CRA dev server, so
// relative `/uploads/...` URLs returned by the backend need the API origin
// prepended. In prod the frontend is served from the same origin as the API,
// so we leave them alone.
const API_ORIGIN = process.env.NODE_ENV === 'development'
  ? (process.env.REACT_APP_API_URL || 'http://localhost:3001')
  : '';

export function resolveUploadUrl(url?: string | null): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  return `${API_ORIGIN}${url}`;
}

export async function authenticatedFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const state = store.getState();
  const jwt = state.auth.jwt;

  const headers: HeadersInit = {
    ...options.headers,
    ...(jwt && { Authorization: `Bearer ${jwt}` }),
  };

  // credentials: 'include' sends the httpOnly session cookie. This is what
  // keeps the user logged in on iOS Safari after ITP wipes localStorage.
  const response = await fetch(url, { ...options, headers, credentials: 'include' });

  if (response.status === 401) {
    store.dispatch(authActions.logout());
    store.dispatch(userActions.clearUser());
    throw new Error('Session expired. Please log in again.');
  }

  return response;
}
